import { render, staticRenderFns } from "./ExamAnswerViewer.vue?vue&type=template&id=a2078fb2&scoped=true"
import script from "./ExamAnswerViewer.vue?vue&type=script&lang=js"
export * from "./ExamAnswerViewer.vue?vue&type=script&lang=js"
import style0 from "./ExamAnswerViewer.vue?vue&type=style&index=0&id=a2078fb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2078fb2",
  null
  
)

export default component.exports